import { SessionContext } from '@wix/da-react-context/pkg/SessionContext';
import { useContext } from 'react';
export function useShouldRenderAdArea(adSafety) {
    const { adsEnabled  } = useContext(SessionContext);
    return adsEnabled && adSafety !== 'off';
}
